import React from "react";
import { useDispatch } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { history } from "../../store/config";
import { SIGN_OUT_PATH } from "../../constants/api";
import BackgroundImage from "../../styles/images/HomeBackground.png";
import {
  ResponsiveBgImage,
  HomeRightSideWrapper,
  ApplicationTitle,
} from "./styles";
import { AdminContactMail } from "../../constants/data"
import { resetAuthenticationStatus } from "../user-profile/actions";
import { CustomButton } from "src/styles/general";

function ErrorComponent() {
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(resetAuthenticationStatus());
    history.replace(SIGN_OUT_PATH);
    window.location.reload();
  };

  return (
    <>
      <Grid container alignItems="stretch">
        <Grid item xs={7} className="picker-select-container">
          <Typography component="div" className="display-flex">
            <ResponsiveBgImage src={BackgroundImage} alt="Background Image" />
            <Typography component="span">
              <ApplicationTitle>CICA</ApplicationTitle>
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <HomeRightSideWrapper>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Typography variant="body1" gutterBottom>
                  Hi,
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" gutterBottom>
                  Your user profile is currently deactivated.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1" gutterBottom>
                  Please contact <a href="mailto:sd.complaints@unicef.org">sd.complaints@unicef.org</a> for more information
                </Typography>
              </Grid>
              <Grid item>
                <CustomButton
                  variant="contained"
                  color="primary"
                  onClick={logout}
                >
                  LOG OUT
                </CustomButton>
              </Grid>
            </Grid>
          </HomeRightSideWrapper>
        </Grid>
      </Grid>
    </>
  );
}

export default ErrorComponent;
